import { Controller } from "@hotwired/stimulus"

// 開発環境専用のログイン切り替えコントローラー
export default class extends Controller {
  static targets = ["select", "form"]

  connect() {
    console.log("DevLogin controller connected")
  }

  change(event) {
    console.log("DevLogin change event fired", event.target.value)
    const userId = event.target.value

    if (!userId) {
      console.log("No user selected, returning")
      return
    }

    // フォームのhidden fieldに選択されたuser_idをセット
    const userIdField = this.formTarget.querySelector('input[name="user_id"]')
    console.log("Setting user_id to:", userId)
    userIdField.value = userId

    // フォームを送信
    console.log("Submitting form")
    this.formTarget.requestSubmit()

    // セレクトボックスをリセット（次回の選択のため）
    setTimeout(() => {
      event.target.selectedIndex = 0
    }, 100)
  }
}
